import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import {
  qrCodeCardsPostPayloadModel,
  qrCodeCardsPutPayloadModel,
  qrCodeCardsResponseModel,
  TableModel
} from './TableCardsManagementAPI.model'

class TableCardsManagementAPI {
  static getTables = (): Promise<TableModel[]> =>
    HTTPInstanceWithPrefix.get('/tables').then(response => response.data)

  static postTables = (numberOfTables: string) =>
    HTTPInstanceWithPrefix.post('/tables', {
      numberOfTables: Number(numberOfTables)
    })

  static deleteTables = (tableIds: string[]) =>
    HTTPInstanceWithPrefix.delete('/tables', {
      data: { ids: tableIds }
    })

  static getQrCodeCards = (): Promise<qrCodeCardsResponseModel> =>
    HTTPInstanceWithPrefix.get('/qr-code-cards').then(response => response.data)

  static putQrCodeCard = (payload: qrCodeCardsPutPayloadModel) => {
    const { id, ...data } = payload
    return HTTPInstanceWithPrefix.put(`/qr-code-cards/${id}`, data)
  }

  static postQrCodeCard = (data: qrCodeCardsPostPayloadModel) =>
    HTTPInstanceWithPrefix.post('/qr-code-cards', data)

  static deleteQrCodeCards = (ids: string[]) =>
    HTTPInstanceWithPrefix.delete(`/qr-code-cards`, { data: { ids } })

  static postQrCodeCardBackgroundImage = (id: string, file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return HTTPInstanceWithPrefix.post(
      `/qr-code-cards/${id}/background`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }
}

export default TableCardsManagementAPI
